import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import { getPublicServices } from "../api";
import { log } from "../lib/log";
import { ServicesMenu, MobileMenu, MAIN_LINKS } from "./header/NavMenus";

export { MAIN_LINKS };

const useScrolled = () => {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return scrolled;
};

const useServices = () => {
  const [services, setServices] = useState([]);
  useEffect(() => { getPublicServices().then((r) => setServices(r.data.items || [])).catch((e) => log.error("services menu:", e)); }, []);
  return services;
};

/** En-tête commun à toutes les pages publiques : menu Services (déroulant), Réalisations, Qualité, Recrutement, Contact + CTA devis. */
const Header = ({ onQuote, solid = false }) => {
  const [open, setOpen] = useState(false);
  const scrolled = useScrolled();
  const services = useServices();
  const loc = useLocation();
  const nav = useNavigate();

  const go = (href) => {
    setOpen(false);
    if (!href.startsWith("/#")) { nav(href); return; }
    if (loc.pathname !== "/") { window.location.href = href; return; }
    document.querySelector(href.slice(1))?.scrollIntoView({ behavior: "smooth" });
  };
  const quote = () => { setOpen(false); if (onQuote) onQuote(); else go("/#devis"); };
  const white = solid || scrolled || open;
  const linkCls = "text-sm font-medium text-neutral-700 hover:text-brand transition-colors";

  return (
    <header className={`${solid ? "sticky" : "fixed"} top-0 left-0 right-0 z-50 transition-all duration-300 ${white ? "bg-white/95 backdrop-blur-md border-b border-neutral-200 py-3" : "bg-transparent py-5"}`} data-testid="site-header">
      <div className="max-w-7xl mx-auto px-5 md:px-8 flex items-center justify-between">
        <a href="/" className="flex items-center gap-2"><img src="/logo.png" alt="PTITSERVICES-PRO" className="h-10 md:h-12 w-auto rounded-md shadow-sm" data-testid="site-logo" /></a>
        <nav className="hidden md:flex items-center gap-7">
          <ServicesMenu services={services} go={go} linkCls={linkCls} />
          {MAIN_LINKS.map((l) => <button key={l.href} onClick={() => go(l.href)} className={l.highlight ? "text-sm font-semibold text-brand bg-brand/10 hover:bg-brand/15 px-3 py-1.5 rounded-full transition-colors" : linkCls} data-testid={`nav-${l.href.split("/").pop().replace("#", "") || "home"}`}>{l.label}</button>)}
        </nav>
        <div className="hidden md:block">
          <button onClick={quote} className="bg-brand hover:bg-brand-dark text-white text-sm font-semibold px-5 py-2.5 rounded-md transition-colors shadow-sm hover:shadow-md" data-testid="nav-quote">Demander un devis</button>
        </div>
        <button className="md:hidden text-neutral-900" onClick={() => setOpen(!open)} aria-label="Menu" data-testid="nav-mobile-toggle">{open ? <X size={26} /> : <Menu size={26} />}</button>
      </div>
      {open && <MobileMenu services={services} go={go} onQuote={quote} />}
    </header>
  );
};

export default Header;
